/**
 * Whether the person is at work, as the browser sees it (ADR-005): a press, a key, the wheel or
 * a touch. Requests the app sends while nobody worked for a while - polling, refetching - are
 * marked as background and do not hold the session open, so a tab left open still reaches the
 * idle timeout.
 */
/**
 * How recently the person must have worked for a request to count as theirs. As long as the
 * polling of the session's time left: every bit of work is carried by at least one request.
 */
export const ACTIVE_WINDOW_MS = 60_000;
const INPUTS = ['pointerdown', 'keydown', 'wheel', 'touchstart'];
let lastWork = Date.now();
/** Counts as work from now on, e.g. „Angemeldet bleiben“ in the warning. */
export function noteActivity(now = Date.now()) {
    lastWork = now;
}
/** Whether a request sent now is the browser's own rather than the person's. */
export function inBackground(now = Date.now()) {
    return now - lastWork >= ACTIVE_WINDOW_MS;
}
/** Listens for the person's input, once per app (`mountApp`). */
export function watchActivity() {
    const note = () => {
        noteActivity();
    };
    for (const type of INPUTS) {
        window.addEventListener(type, note, { capture: true, passive: true });
    }
}
//# sourceMappingURL=activity.js.map